<template>
  <div>
    <datalist id="towns-list">
      <option v-for="town in towns.keys()"> {{ town }}</option>
    </datalist>
    <datalist id="nations-list">
      <option v-for="nation in nations.keys()"> {{ nation.toUpperCase() }}</option>
    </datalist>

    <b-form-row>
      <b-form-group class="col-md-12">
        <b-form-group>
          <b-form-radio-group
            id="residence-nation"
            v-model="residenceNation"
            :options="options"
            v-on:change="initResidence()"
            name="radio-options"
          ></b-form-radio-group>
        </b-form-group>
        <b-form-row>
          <b-form-group label="Via" class="col-md-8">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="street"
                v-model="detail.residenceStreet"
                v-on:change="save"
                name="Via"
                v-validate="{ required: true }"
                :state="stateValidation('Via')"
                aria-describedby="input-street-feedback"/>
              <b-form-invalid-feedback id="input-street-feedback">{{
                  veeErrors.first('Via')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="Numero civico" class="col-md-2">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="civic-number"
                v-model="detail.residenceCivicNumber"
                v-on:change="save"
                name="Numero Civico"
                v-validate="{ required: true, max: 15 }"
                :state="stateValidation('Numero Civico')"
                aria-describedby="input-civicnumber-feedback"/>
              <b-form-invalid-feedback id="input-civicnumber-feedback">{{
                  veeErrors.first('Numero Civico')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="CAP" class="col-md-3" v-if="residenceNation === 'Italy'">
            <b-form-input
              autocomplete="off"
              id="postal-code"
              v-model="detail.residencePostalCode"
              v-on:change="save"
              name="CAP"
              v-validate="{ required: true, numeric: true, min: 5, max: 5 }"
              :state="stateValidation('CAP')"
              aria-describedby="input-postalcode-feedback"/>
            <b-form-invalid-feedback id="input-postalcode-feedback">{{
                veeErrors.first('CAP')
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Città" class="col-md-4" v-if="residenceNation === 'Italy'">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="it-residence-city"
                v-on:input="handleSearchInput"
                v-on:blur="validateResidenceCity()"
                v-model="detail.residenceTown"
                name="Luogo di nascita"
                :state="stateValidation('Luogo di nascita')"
                aria-describedby="input-residence-feedback"
              />

              <div style="position: relative">
                <div v-if="filteredList.length > 0 && isResidenceSearchActive" class="suggestions-list">
                  <div
                    v-for="(item, index) in filteredList"
                    :key="index"
                    class="suggestion-item"
                    @click="handleResidenceSelection(item)"
                  >
                    {{ item.name }} - {{ item.provinceCode }}
                  </div>
                </div>
              </div>
              <b-form-invalid-feedback id="input-city-feedback">
                {{ veeErrors.first('Città') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Città estera" class="col-md-4" v-if="residenceNation === 'Foreign'">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="foreign-town"
                v-model="detail.residenceTown"
                v-on:change="save"
                name="Città estera"
                v-validate="{ required: true }"
                :state="stateValidation('Città estera')"
                aria-describedby="input-city-feedback"/>
              <b-form-invalid-feedback id="input-city-feedback">{{
                  veeErrors.first('Città estera')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Provincia" class="col-md-2" v-if="residenceNation === 'Italy'">
            <b-form-input
              id="province"
              readonly
              v-model="detail.residenceProvince"
              v-on:change="save"
              name="Provincia"
              v-validate="{ required: true, min: 2, max: 2 }"
              :state="stateValidation('Provincia')"
              aria-describedby="input-province-feedback"/>
            <b-form-invalid-feedback id="input-province-feedback">
              {{ veeErrors.first('Provincia') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Nazione" class="col-md-3" v-if="residenceNation === 'Foreign'">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="nation"
                list="nations-list"
                v-model="detail.residenceNation"
                v-on:change="save"
                name="Nazione"
                v-validate="validateNation()"
                :state="stateValidation('Nazione')"
                aria-describedby="input-nation-feedback"/>
              <b-form-invalid-feedback id="input-nation-feedback">{{
                  veeErrors.first('Nazione')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-form-row>
      </b-form-group>
    </b-form-row>
  </div>
</template>

<script>
import TownsApi from "@/api/TownsApi";
import NationsApi from "@/api/NationsApi";

export default {
  name: 'ResidenceSelect',
  props: {
    value: {},
    eventName: {}
  },
  inject: ["parentValidator"],
  data: () => ({
    selected: null,
    residenceNation: 'Italy',
    nations: [],
    options: [
      {text: 'Italia', value: 'Italy'},
      {text: 'Straniero', value: 'Foreign'},
    ],
    towns: [],
    detail: {
      residenceStreet: null,
      residenceCivicNumber: null,
      residenceTown: null,
      residencePostalCode: null,
      residenceProvince: null,
      residenceNation: null
    },
    residenceSearch: '',
    isResidenceSearchActive: false,
  }),
  created() {
    this.initTownsAndNations()
    this.detail.residenceStreet = this.value.residenceStreet
    this.detail.residenceCivicNumber = this.value.residenceCivicNumber
    this.detail.residenceTown = this.value.residenceTown
    this.detail.residencePostalCode = this.value.residencePostalCode
    this.detail.residenceProvince = this.value.residenceProvince
    this.detail.residenceNation = this.value.residenceNation
    this.residenceNation = (this.value.residenceNation.toUpperCase() === 'ITALIA') ? 'Italy' : 'Foreign'

    this.$validator = this.parentValidator
  },
  computed: {
    filteredList() {
      return this.towns.filter(item => {
        const search = this.residenceSearch.toLowerCase()
        return (
          item.name.toLowerCase().includes(search)
        )
      })
    }
  },
  methods: {
    handleSearchInput(value) {
      console.log("TEsto cambiato Residence Select")
      this.residenceSearch = value
      this.isResidenceSearchActive = true
    },
    handleResidenceSelection(value) {
      this.detail.residenceTown = value.name;
      this.fillResidenceProvince(value.provinceCode);
      this.isResidenceSearchActive = false
    },
    initTownsAndNations() {
      TownsApi.nonDismissed().then((result) => {
        this.towns = result
      })

      NationsApi.all().then((result) => {
        this.nations = new Map(result.map((nation) => [nation.name, nation.codeIsoAlpha3]))
        this.nations.set("Italia", "ITA")
      })
    },
    reset() {
      this.selected = null
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) return !this.veeErrors.has(ref)
      else return null
    },
    initResidence() {
      this.detail.residenceNation = this.residenceNation
      this.detail.residenceTown = null
      this.detail.residenceProvince = this.residenceNation === 'Italy' ? null : "EE"
      this.detail.residenceStreet = null
      this.detail.residenceCivicNumber = null
      this.detail.residenceNation = this.residenceNation === 'Italy' ? "ITALIA" : null
      this.detail.residencePostalCode = null

      this.$forceUpdate()
    },
    fillResidenceProvince() {
      if (this.residenceNation === 'Italy') {
        this.detail.residenceProvince = this.towns.get(this.detail.residenceTown)
        this.$forceUpdate()
      }
    },
    validateResidenceCity() {
      if (!this.towns.get(this.detail.residenceTown)) {
        this.detail.residenceTown = ''
      }
    },
    validateNation() {
      let validNations = Array.from(this.nations.keys())
      let validNationsRegex = validNations.map(nation => nation.toUpperCase()).join('|')
      return {required: true, regex: validNationsRegex}
    },
    validateTown() {
      let validTowns = Array.from(this.towns.keys())
      let validTownsRegex = validTowns.map(town => town.toUpperCase()).join('|')
      if (this.detail.residenceNation === 'ITALIA') {
        return {required: true, regex: validTownsRegex}
      } else {
        return {required: false}
      }
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit(this.eventName, this.detail)
        }
      })
    }
  }
}
</script>

<style>
.suggestions-list {
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  position: absolute;
  width: 100%;
  z-index: 50;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
  background: white;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
}
</style>
